import { OnInit } from "@angular/core";
var SelectComponent = /** @class */ (function () {
    function SelectComponent() {
    }
    SelectComponent.prototype.ngOnInit = function () { };
    return SelectComponent;
}());
export { SelectComponent };
